import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\FileUploadController::deleteMethod
* @see app/Http/Controllers/Teacher/FileUploadController.php:19
* @route '/teacher/files/delete'
*/
export const deleteMethod = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: deleteMethod.url(options),
    method: 'post',
})

deleteMethod.definition = {
    methods: ["post"],
    url: '/teacher/files/delete',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\FileUploadController::deleteMethod
* @see app/Http/Controllers/Teacher/FileUploadController.php:19
* @route '/teacher/files/delete'
*/
deleteMethod.url = (options?: RouteQueryOptions) => {
    return deleteMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\FileUploadController::deleteMethod
* @see app/Http/Controllers/Teacher/FileUploadController.php:19
* @route '/teacher/files/delete'
*/
deleteMethod.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: deleteMethod.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\FileUploadController::url
* @see app/Http/Controllers/Teacher/FileUploadController.php:89
* @route '/teacher/files/url'
*/
export const url = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: url.url(options),
    method: 'post',
})

url.definition = {
    methods: ["post"],
    url: '/teacher/files/url',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\FileUploadController::url
* @see app/Http/Controllers/Teacher/FileUploadController.php:89
* @route '/teacher/files/url'
*/
url.url = (options?: RouteQueryOptions) => {
    return url.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\FileUploadController::url
* @see app/Http/Controllers/Teacher/FileUploadController.php:89
* @route '/teacher/files/url'
*/
url.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: url.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\FileUploadController::signedUploadUrl
* @see app/Http/Controllers/Teacher/FileUploadController.php:149
* @route '/teacher/files/signed-upload-url'
*/
export const signedUploadUrl = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: signedUploadUrl.url(options),
    method: 'post',
})

signedUploadUrl.definition = {
    methods: ["post"],
    url: '/teacher/files/signed-upload-url',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\FileUploadController::signedUploadUrl
* @see app/Http/Controllers/Teacher/FileUploadController.php:149
* @route '/teacher/files/signed-upload-url'
*/
signedUploadUrl.url = (options?: RouteQueryOptions) => {
    return signedUploadUrl.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\FileUploadController::signedUploadUrl
* @see app/Http/Controllers/Teacher/FileUploadController.php:149
* @route '/teacher/files/signed-upload-url'
*/
signedUploadUrl.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: signedUploadUrl.url(options),
    method: 'post',
})

const files = {
    delete: Object.assign(deleteMethod, deleteMethod),
    url: Object.assign(url, url),
    signedUploadUrl: Object.assign(signedUploadUrl, signedUploadUrl),
}

export default files